module.exports = __webpack_public_path__ + "img/posterBg2-3.d7bd9720.png";